import ProjectTemplate from '../../components/common/ProjectTemplate';

const StatisticsPage = () => {
    return (
        <ProjectTemplate>
            Statistics Page
        </ProjectTemplate>
    );
};

export default StatisticsPage;
